// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2RyAh","list":"styles_list__CFvP6"};